import './App.css';

import ContactForm from './comps/ContactForm'

function App() {
    
    return (
        <ContactForm />
    )
  
}

export default App;
